// extracted by mini-css-extract-plugin
export default {"recos":"h7-z","productCardOverride":"i7-z","rowHasBadge":"j7-z"};